// ─────────────────────────────────────────────────────────────
// TARA AURORA — central editable content
// Edit text, links and resources here. Final assets (Amazon URL,
// MailerLite embed, book cover image, resource files) slot in below.
// ─────────────────────────────────────────────────────────────

export const BRAND = "TARA AURORA";
export const BOOK_TITLE = "REGULATE";
export const BOOK_TAGLINE = "Calm the Nervous System. Heal the Root. Live with Choice.";

// TODO: replace with the final Amazon book page URL
export const AMAZON_URL = "https://www.amazon.com/dp/PLACEHOLDER";

// Chapter One audio — currently streamed from the Suno CDN file behind the
// provided share link (suno.com/s/OKVx1WV8puOOCcYl). Replace with the final
// permanent MP3 / hosted audio URL when supplied.
export const CHAPTER_ONE_AUDIO_URL =
  "https://cdn1.suno.ai/4b33ea3d-4986-49b2-845e-a2808bf31d6c.mp3";

// Quiet Mind guided-audio MP3 — hosted in this project (frontend/public/audio).
export const QUIET_MIND_AUDIO_URL = "/audio/quiet-mind.mp3";
export const GROUNDING_AUDIO_URL = "/audio/grounding.mp3";
export const SLEEP_AUDIO_URL = "/audio/sleep.mp3";
export const FEELINGS_AUDIO_URL = "/audio/feelings.mp3";
export const CHAPTER_ONE_PDF_URL = "/docs/regulate-chapter-one.pdf";

// TODO: when MailerLite is ready, replace the API call in
// src/components/NewsletterForm.jsx with the MailerLite embed or API.
export const MAILERLITE_NOTE = "Placeholder form — connects to MailerLite later.";

// Final REGULATE 3D cover mockup (trimmed, served from /public).
export const BOOK_COVER_IMAGE = "/regulate-cover-3d.png";

export const SEO = {
  home: {
    title: "Tara Aurora — You were never meant to live in survival mode",
    description:
      "Come back to your body. Understand what it’s been trying to tell you. Learn to live with more safety, steadiness, and choice.",
  },
  regulate: {
    title: "REGULATE by Tara Aurora — Calm the Nervous System. Heal the Root. Live with Choice.",
    description:
      "REGULATE isn’t another book about becoming a better version of yourself. It’s an invitation to understand the version of you that learned to survive.",
  },
  beginHere: {
    title: "Begin Here — Free practices & guides from Tara Aurora",
    description:
      "A quiet place to begin. Free nervous-system practices, grounding audio, guides and the REGULATE introduction.",
  },
  about: {
    title: "About Tara Aurora",
    description:
      "Tara Aurora writes about the places where neuroscience, nervous-system regulation, somatic awareness and the deeper wisdom of the body meet.",
  },
};

export const RECOGNITION_EXPERIENCES = [
  "Overthinking",
  "Exhaustion",
  "Irritability",
  "Difficulty resting",
  "Feeling responsible for everyone",
  "Reaching for something to take the edge off",
  "Knowing what you should do, but struggling to actually feel different",
];

export const PRINCIPLES = [
  {
    number: "01",
    title: "UNDERSTAND",
    text: "Learn the language of your nervous system.",
  },
  {
    number: "02",
    title: "REGULATE",
    text: "Give your body experiences of safety.",
  },
  {
    number: "03",
    title: "RECONNECT",
    text: "Return to sensation, emotion, pleasure and intuition.",
  },
  {
    number: "04",
    title: "CHOOSE",
    text: "Respond to life rather than automatically reacting to it.",
  },
];

export const PAUSE_LINES = [
  "Unclench your jaw.",
  "Let your shoulders fall.",
  "Feel the surface underneath you.",
  "You don’t have to solve anything in this moment.",
  "Just notice that you’re here.",
];

// Free resources — grows over time. Set published: false to keep a
// resource hidden until it's ready. Each maps to a MailerLite group that
// triggers its single-resource delivery automation; the complete collection
// maps to one combined automation.
export const RESOURCES = [
  {
    slug: "feel-grounded",
    need: "I need to feel more grounded.",
    type: "Free nervous-system practice",
    description:
      "A short, gentle practice to help you land back in your body and feel the steadiness that’s already underneath you — no experience needed.",
    cta: "Send Me the Practice",
    group: "Freebie – Grounded",
    published: true,
  },
  {
    slug: "quiet-mind",
    need: "I can’t shut my mind off.",
    type: "Grounding practice",
    description:
      "A gentle grounding practice for when your thoughts won’t stop looping and you need to land back in your body.",
    cta: "Send Me the Practice",
    group: "Freebie – Quiet Mind",
    published: true,
  },
  {
    slug: "understand-feelings",
    need: "I want to understand what I’m feeling.",
    type: "Free guide",
    description:
      "A quiet written guide to help you name, locate and make sense of what’s moving through you.",
    cta: "Send Me the Guide",
    group: "Freebie – Feelings",
    published: true,
  },
  {
    slug: "sleep",
    need: "I need help settling into sleep.",
    type: "Sleep audio",
    description:
      "A slow audio companion to help your system soften its guard and settle toward rest.",
    cta: "Send Me the Sleep Audio",
    group: "Freebie – Sleep",
    published: true,
  },
  {
    slug: "regulate-intro",
    need: "I want to understand my nervous system.",
    type: "REGULATE introduction",
    description:
      "Read the opening of REGULATE — an introduction to the language your body has been speaking all along.",
    cta: "Send Me the REGULATE Excerpt",
    group: "Freebie – REGULATE Excerpt",
    published: true,
  },
];

export const COMPLETE_COLLECTION_GROUP = "Freebie – Complete Collection";

export const MARQUEE_PHRASES = [
  "Calm the Nervous System",
  "Heal the Root",
  "Live with Choice",
];
